import * as React from "react";
import PropTypes from "prop-types";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import { useLocation } from "react-router-dom";
const drawerBleeding = 19;

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor:
    theme.palette.mode === "light"
      ? grey[100]
      : theme.palette.background.default,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "light" ? "#fff" : grey[800],
}));

const Puller = styled(Box)(({ theme }) => ({
  width: 72,
  height: 6,
  backgroundColor: theme.palette.mode === "light" ? grey[300] : grey[900],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 36px)",
}));

function BottomSheet(props) {
  const { window } = props;
  const location = useLocation();
  // This is used only for the example
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            overflow: "visible",
          },
        }}
      />

      <Drawer
        container={container}
        anchor="bottom"
        open={props.open}
        onClose={() => props.handleOpen(false, false)}
      >
        <StyledBox
          sx={{
            position: "absolute",
            top: -drawerBleeding,
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15,
            visibility: "visible",
            right: 0,
            left: 0,
            backgroundColor: "#ffffff",
          }}
        >
          <Puller />
          <Typography sx={{ p: 0, color: "#ffffff" }}>51 results</Typography>
        </StyledBox>
        <StyledBox
          sx={{
            px: 2,
            pb: 2,

            overflow: "auto",
            backgroundColor: "#ffffff",
          }}
        >
          <Box
            sx={{
              height: location.pathname.includes("/app/UploadMusic")
                ? "50vh"
                : "auto",
            }}
          >
            {props.actions.map((action, index) => (
              <Typography
                key={index}
                sx={{ p: 2, color: "#000000", cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  props.handleOpen(
                    false,
                    action["genre"] ? action["genre"] : action
                  );
                }}
              >
                {action["genre"] ? action["genre"] : action}
              </Typography>
            ))}
          </Box>
        </StyledBox>
      </Drawer>
    </Root>
  );
}

BottomSheet.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default BottomSheet;
